/**
 * Frontend Configuration
 * Centralized configuration for API endpoints and environment settings
 */

// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// API Configuration
export const API_CONFIG = {
  // Backend API URL
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.smartclose.app',
  
  // Timeout settings
  TIMEOUT: 30000, // 30 seconds
  
  // Stripe configuration
  STRIPE: {
    PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51Q...', // Will be fetched from backend
  },
  
  // Auth endpoints
  AUTH: {
    LOGIN: '/login',
    SIGNUP: '/signup',
    LOGOUT: '/logout',
    REFRESH: '/auth/refresh',
    VERIFY: '/auth/verify'
  },
  
  // Billing endpoints
  BILLING: {
    CONFIG: '/api/billing/config',
    CREATE_PAYMENT_METHOD: '/api/create-payment-method',
    SUBSCRIPTION: '/api/billing/subscription',
    INVOICES: '/api/billing/invoices'
  },
  
  // Data endpoints
  DATA: {
    CONNECTIONS: '/api/connections',
    USERS: '/api/users',
    INVITATIONS: '/api/invitations'
  }
};

// Feature flags
export const FEATURE_FLAGS = {
  PHONE_FEATURE_ENABLED: false,
  BILLING_ENABLED: true,
  OAUTH_ENABLED: true
};

// App configuration
export const APP_CONFIG = {
  NAME: 'SmartClose',
  VERSION: '1.0.0',
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  DEBUG: isDevelopment
};

// Export environment helpers
export const ENV = {
  isDevelopment,
  isProduction,
  isTest: process.env.NODE_ENV === 'test'
};

const config = {
  API_CONFIG,
  FEATURE_FLAGS,
  APP_CONFIG,
  ENV
};

export default config;